export enum Sections {
    CONTACT_DETAILS = 'Contact Details',
    LEAD_INFORMATION = 'Lead Information',
    LEAD_DETAILS = 'Lead Details',
    ADDRESS_DETAILS = 'Address Details'
}